import * as React from "react"
const VideoFileIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={40}
    fill="none"
    {...props}
  >
    <path
      stroke="#338AFF"
      strokeWidth={2}
      d="m1.595 10.357 8.898-8.78A2 2 0 0 1 11.898 1H28a3 3 0 0 1 3 3v32a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V11.78a2 2 0 0 1 .595-1.423Z"
    />
    <path
      stroke="#338AFF"
      strokeWidth={2}
      d="M11 2v9a1 1 0 0 1-1 1H2m9 19.596V20.404a.25.25 0 0 1 .362-.223l11.19 5.595a.25.25 0 0 1 0 .448l-11.19 5.595a.25.25 0 0 1-.362-.223Z"
    />
  </svg>
)
export default VideoFileIcon